import gql from "graphql-tag";

export const DISCOUNT_MUTATION = gql`
  mutation CalculateDiscount($input: DiscountInput!) {
    calculateDiscount(input: $input) {
      promotionCode
      fullPrice
      amount
      discount
      bin {
        codes
        name
      }
      priceIds
    }
  }
`;
